/** Shared „Mehr anzeigen“ / „Weniger anzeigen“ control for the home sidebars. */
export function IntranetShowMore({
  label,
  onClick,
}: {
  label: 'Mehr anzeigen' | 'Weniger anzeigen';
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="min-h-11 px-3 text-sm font-medium text-primary focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:outline-none"
      onClick={onClick}
    >
      {label}
    </button>
  );
}
